import React from 'react';
import PropTypes from 'prop-types';
import { CircularProgressbar } from 'react-circular-progressbar';
import './CustomCircleProgressBar.scss';

const CustomCircleProgressBar = ({ totalItems, currentValue }) => (
  <CircularProgressbar
    className="custom-circle-progress-bar__progress"
    value={currentValue}
    maxValue={totalItems}
    text={`${currentValue} of ${totalItems}`}
  />
);

CustomCircleProgressBar.propTypes = {
  totalItems: PropTypes.number.isRequired,
  currentValue: PropTypes.number.isRequired,
};

export default CustomCircleProgressBar;
